import { render, staticRenderFns } from "./CardOffer.vue?vue&type=template&id=adb36b52&"
import script from "./CardOffer.vue?vue&type=script&lang=js&"
export * from "./CardOffer.vue?vue&type=script&lang=js&"
import style0 from "./CardOffer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports